<template>
	<i>
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_5737_6256)">
				<path
					d="M5.91204 11.6757C4.2499 11.6757 2.8526 11.1084 1.72014 9.97399C0.587704 8.83953 0.0214844 7.45935 0.0214844 5.83345C0.0214844 4.20755 0.588713 2.82883 1.72317 1.6973C2.85763 0.565766 4.23781 0 5.86371 0C7.48961 0 8.86833 0.566803 9.99986 1.70041C11.1314 2.83402 11.6972 4.21424 11.6972 5.84108C11.6972 6.50198 11.6035 7.1027 11.4161 7.64324C11.2287 8.18378 10.9548 8.6991 10.5945 9.18919L15.7188 14.2703C15.9062 14.4657 15.9999 14.7054 15.9999 14.9893C15.9999 15.2733 15.9062 15.5129 15.7188 15.7081C15.5122 15.9027 15.2726 16 15 16C14.7274 16 14.4913 15.8991 14.2918 15.6973L9.22088 10.6162C8.78164 10.9466 8.28484 11.2058 7.73048 11.3938C7.17612 11.5817 6.56997 11.6757 5.91204 11.6757ZM5.86886 9.70811C6.96414 9.70811 7.88141 9.33663 8.62068 8.59369C9.35996 7.85075 9.72959 6.93511 9.72959 5.84675C9.72959 4.75839 9.35953 3.83976 8.61941 3.09088C7.8793 2.342 6.96308 1.96757 5.87076 1.96757C4.76644 1.96757 3.84341 2.342 3.10166 3.09088C2.35992 3.83976 1.98905 4.75839 1.98905 5.84675C1.98905 6.93511 2.35886 7.85075 3.09848 8.59369C3.83811 9.33663 4.76157 9.70811 5.86886 9.70811Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5737_6256">
					<rect
						width="15.9784"
						height="16"
						fill="currentColor"
						transform="translate(0.0214844)"
					/>
				</clipPath>
			</defs>
		</svg>
	</i>
</template>
